import React from "react";

function Card({ link, ...props }) {
  return (
    <div
      className={`card bg-white text-center rounded-3xl  shadow-card  ${props.className}`}
    >
      {props.children}
    </div>
  );
}

export { Card };
//pt-xl pb-md
function ShortInfoCard({ firstTxt, secondTxt, color, ...props }) {
  return (
    <div
      className={`flex flex-row bg-white rounded-soft py-md items-center justify-center shadow-card ${props.className}`}
    >
      <div className=" px-xl ">
        <p>{firstTxt}</p>
      </div>
      {props.children}
      <div className="w-[1px] h-[2rem] bg-rule "></div>
      <div className="flex flex-row px-xl">
        <p className={`${color}`}>{secondTxt}</p>
      </div>
    </div>
  );
}

export { ShortInfoCard };
